import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ResourceItem_EditorRendererV2.scss';
import { LL_H_C, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { BadImplementationException, cloneArr } from '@nu-art/ts-common';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { HCSDropDowns } from '../../shared-components/index.js';
import { HCS_MultiSelect } from '../../shared-components/app-multis-select.js';
import { QuaiManager_DropDownCaret } from '@app/styles/frontend/ui/ui-manager/consts';
import { ConfigKeyFE_SourceTagId, ModuleFE_Tag, ModuleFE_Variable } from '../../../_entity.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { DropDown_Tag } from '../../../_entity/tag/ui-components.js';
import { MultiSelect_Variable } from '../../../_entity/variable/ui-components.js';
import { DropDown_ResourceType } from '../../../_entity/resource/ui-components.js';
export class ResourceItem_EditorRendererV2 extends TS_EditableItemComponentProto {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    multiselectPropsTags = {
        // label: 'Select Tags Properties',
        itemRenderer: (tagId) => _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: async () => {
                        if (tagId)
                            await this.removeVariableId(tagId, 'tagsProperties');
                    }, className: 'ts-icon__small' }), ModuleFE_Tag.cache.unique(tagId).label] }),
        selectionRenderer: DBItemDropDownMultiSelector.selector(HCSDropDowns.Tag)
    };
    // private selectedIcon = (icon: Icon) => {
    // 	this.props.editable.update('icon', icon.key);
    // };
    async removeVariableId(varId, prop) {
        const propertiesId = cloneArr(this.props.editable.item[prop]);
        propertiesId.splice(propertiesId.indexOf(varId), 1);
        await this.props.editable.updateObj({ [prop]: propertiesId });
        this.forceUpdate();
    }
    render() {
        const editMode = this.state.editMode;
        const sourceTagId = ConfigKeyFE_SourceTagId.get();
        if (!sourceTagId || sourceTagId.length === 0)
            throw new BadImplementationException('Can\'t find source tag id from AppConfig collection!');
        return (_jsx("div", { className: 'match_parent resource-editor', children: _jsxs(LL_V_L, { className: 'container', children: [_jsx("div", { className: 'form-title', children: "Resource Info" }), _jsx(TS_PropRenderer.Vertical, { label: 'Resource Name', children: _jsx(DefaultEditor_InputText, { disabled: !editMode, editable: this.state.editable, prop: 'label', showErrorTooltip: true }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Type', children: _jsx(DropDown_ResourceType.editable, { editable: this.state.editable, prop: 'type', showErrorTooltip: true, disabled: !editMode }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Tag', children: _jsx(DropDown_Tag.editable, { editable: this.state.editable, prop: 'tagId', queryFilter: tag => tag.tagIds.length === 1 && tag.tagIds.includes(sourceTagId), disabled: !editMode, showErrorTooltip: true, caret: QuaiManager_DropDownCaret }) }), this.renderVarEditor(), this.renderTagsEditor()] }) }));
    }
    renderTagsEditor() {
        const editable = this.props.editable;
        const editMode = this.state.editMode;
        if (!editMode)
            return _jsxs(LL_V_L, { children: [editable.item.tagsProperties?.length ?
                        _jsx("div", { className: 'checkbox-titles', children: "Tags Properties" }) : null, _jsx(LL_H_C, { className: 'match_width variable-list', children: editable.item.tagsProperties?.map((tagId, index) => {
                            const tag = ModuleFE_Tag.cache.unique(tagId);
                            if (!tag)
                                return '';
                            return (_jsx(LL_H_C, { className: 'tag', children: tag.label }, index));
                        }) })] });
        return _jsx(HCS_MultiSelect.Tag, { editable: editable, prop: 'tagsProperties' });
    }
    renderVarEditor() {
        const editable = this.props.editable;
        const editMode = this.state.editMode;
        if (!editMode)
            return _jsxs(LL_V_L, { children: [editable.item.variableProperties?.length ?
                        _jsx("div", { className: 'checkbox-titles', children: "Variables Properties" }) : null, _jsx(LL_H_C, { className: 'match_width variable-list', children: editable.item.variableProperties?.map((varId, index) => {
                            const variable = ModuleFE_Variable.cache.unique(varId);
                            if (!variable)
                                return '';
                            return (_jsx(LL_H_C, { className: 'tag', children: variable.name }, index));
                        }) })] });
        return _jsx(MultiSelect_Variable, { editable: editable, prop: 'variableProperties' });
    }
}
//# sourceMappingURL=ResourceItem_EditorRendererV2.js.map